import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

function MapComponent() {
    const lagosPosition = [6.6053, 3.3499]; // Lagos coordinates (approximate)
    const abujaPosition = [9.0676, 7.4328]; // Abuja coordinates (approximate)

    return (
        <MapContainer center={lagosPosition} zoom={7} style={{ height: '300px', width: '100%' }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={lagosPosition}>
                <Popup>
                    <b>Lagos Office</b><br />
                    Inside Eridan Place, Oluwalogbon House,<br />
                    Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos
                </Popup>
            </Marker>
            <Marker position={abujaPosition}>
                <Popup>
                    <b>Abuja Office</b><br />
                    2nd floor Puskin mall,<br />
                    Samuel Mafuyi Street, Jabi, Abuja
                </Popup>
            </Marker>
        </MapContainer>
    );
} 

export default MapComponent;